import React from 'react'
import PropTypes from 'prop-types'
import {Blocks} from '@builder.io/sdk-react'
import {defaultDetail} from './defaultConfig'
import {CustomAccordionDetail} from '@/components/accordion'

export const BuilderAccordionDetail = ({
    attributes,
    content = [],
    builderBlock,
    'data-testid': dataTestId
}) => {
    const {className, ...restAttributes} = attributes

    return (
        <CustomAccordionDetail
            className={className}
            {...restAttributes}
            data-testid={dataTestId || 'accordionDetail-AccordionDetail'}
            renderContent={() => (
                <Blocks
                    path="component.options.content"
                    blocks={content}
                    parent={builderBlock?.id}
                    data-testid="accordionDetail-Blocks"
                />
            )}
        />
    )
}

BuilderAccordionDetail.propTypes = {
    attributes: PropTypes.object,
    content: PropTypes.arrayOf(PropTypes.object.isRequired),
    builderBlock: PropTypes.object,
    'data-testid': PropTypes.string
}

export const AccordionDetailDefinition = {
    component: BuilderAccordionDetail,
    name: 'AccordionDetail',
    noWrap: true,
    canHaveChildren: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    defaultStyles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch'
    },
    inputs: [
        {
            name: 'content',
            type: 'uiBlocks',
            broadcast: true,
            defaultValue: defaultDetail
        }
    ]
}
